import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import toasterInfo from "../../interfaces/toaster-info";
import styles from "./Toaster.module.scss";

function Toaster(params:any) {
  const { info } = params;
  const {
    toasterType,
  } = info as toasterInfo;

  let message: string;
  if (toasterType === "email") message = "Email Sent";
  else if ((toasterType === "ewallet")) message = "Transaction Successful";
  else if ((toasterType === "refund")) message = "Refund Successful";
  else if ((toasterType === "stf")) message = "Redemption Successful";


  const success = () => toast.success(message, {
    className: styles.green,
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    draggable: true,
    progress: undefined,
    toastId: "success1",
  });
  success();
  return (
    <ToastContainer />
  );
}

export default Toaster;
